import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import "./stream_actions"

ActiveStorage.start()
